import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import VI from "./vi.json";
import EN from "./en.json";

const resources = {
  vi: {
    translation: VI,
  },
  en: {
    translation: EN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "vi",
  // #55872: localStorage "language" đôi khi bị ghi HOA ("EN") ở luồng OBD/first-login.
  // resources key là "en"/"vi" (thường), nên lng="EN" không khớp -> i18n rơi về tiếng Việt
  // dù header API gửi EN. lowerCaseLng ép "EN"->"en" cho cả init lẫn changeLanguage.
  lowerCaseLng: true,
  nsSeparator: false,
  keySeparator: false,
  // t() luon tra ve chuoi, khong bao gio null - xem src/i18n/i18next.d.ts
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
